import { z } from 'zod';

/**
 * 认证表单验证模式
 * 登录时 username 不展示，表单项仍为 ''，需允许空串否则校验会拦下登录请求
 */
export const authSchema = z.object({
  email: z.string().email('请输入有效的邮箱地址'),
  password: z.string().min(6, '密码至少6位'),
  username: z.union([z.string().min(1, '用户名不能为空'), z.literal('')]).optional(),
});

export type AuthFormData = z.infer<typeof authSchema>;
